/** @jsx jsx */
import * as React from "react"
import { jsx } from "@emotion/core";
import CTAStyle from "../../styles/components/CallToAction";

export enum CTATheme {
    "PRIMARY" = "PRIMARY",
    "SECONDARY" = "SECONDARY",
    "TEXTUAL" = "TEXTUAL",
    "TEXTUAL_UNDERLINE" = "TEXTUAL_UNDERLINE",
    "LIGHT" = "LIGHT"
}

interface CTAProps {
    innerText: string,
    theme: CTATheme,
    onClick: (event: React.MouseEvent) => void
    disabled?: boolean,
    customStyle?: any
}

const CTA = (props: CTAProps) => {
    return (
        <div css={CTAStyle(props.theme, props.customStyle, props.disabled)} onClick={e => props.disabled ? {} : props.onClick(e)}>
            {props.innerText || ""}
        </div>
    )
}

export default CTA